import { GetConnectionStatus } from '@packages/domain/ssm5';
import { container } from '@web/services/container';

const [$getConnectionStatus] = container.resolveOperations(GetConnectionStatus);

/** What a status check said about a connection. */
export type Ssm5ConnectionStatus = 'gone' | 'open' | 'unreachable';

/**
 * Ask the backend whether a connection is still open on its Cloud Connector. A check that throws,
 * aborted or not, reads as unreachable; a caller that aborted ignores the answer anyway.
 *
 * @param cloudConnectorId - the Cloud Connector ID the connection runs through
 * @param signal - aborts the check
 * @returns what the backend said
 */
export async function checkConnection(cloudConnectorId: string, signal: AbortSignal): Promise<Ssm5ConnectionStatus> {
    try {
        return (await $getConnectionStatus({ cloudConnectorId, signal })) ? 'open' : 'gone';
    } catch {
        return 'unreachable';
    }
}
